export default function DoNotSell() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Do Not Share or Sell My Information</h1>

        <p>

          Hopeful Horizons NY does not sell personal information to third parties.

        </p>

        <p>

          Information submitted through the website is used only for the purpose of connecting families and service providers.

        </p>

        <p>

          If you have concerns about your information or would like to request removal of your data, please contact us through the Contact page.

        </p>

      </div>

    </div>

  );

}